import { Modal } from 'antd';
import React, { useState } from 'react'
import styled from 'styled-components';
import { ModalCrossIcon } from '../utils/Images';
import { cancelsubscription } from '../collection/ApiCollection';
import { toast } from 'react-toastify';

const CancelSubscription = ({ openModal, handleCancelModal,handleGetCurrentPlan }) => {
    const [loader, setLoader] = useState(false)

    const handleCancelSub = async () => {
        try {
            setLoader(true)
            let res = await cancelsubscription();
            if (res.status === 200) {
                setLoader(false)
                toast.success("Subscription cancel successfully")
                handleCancelModal();
                handleGetCurrentPlan()
            } else {
                setLoader(false)
                toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
            }
        } catch (error) {
            setLoader(false)
            toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
        }
    }
    return (
        <Modal centered open={openModal} onOk={handleCancelModal} onCancel={handleCancelModal} footer={false}>
            <CancelSubscriptionWrapper>
                <p>Are you sure you want to<br /> cancel your subscription?</p>
                <div className='img-div'>
                    <img src={ModalCrossIcon} alt="" />
                </div>
                <div className='btn-div'>
                    <button className='yes-btn' onClick={() => handleCancelSub()}>{loader ? "Loading..." : "YES"}</button>
                    <button className='no-btn' onClick={() => handleCancelModal()}>NO</button>
                </div>
            </CancelSubscriptionWrapper>
        </Modal>
    )
}

export default CancelSubscription;

const CancelSubscriptionWrapper = styled.div`
    padding-bottom:30px;
    p{
        font-weight:700;
        font-size:19px;
        margin-bottom:29px;
        margin-top:10px;
        text-align:center;
    }
    .img-div{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:center;
        img{
            width:135px;
            height:135px;
            margin:auto;
        }
    }
    .btn-div{
        width:100%;
        display:flex;
        gap:65px;
        justify-content:center;
        margin-top:66px;

        .yes-btn{
            color:#fff;
            font-weight:700;
            font-size:16px;
            height:48px;
            padding: 0px 49px;
            border-radius: 15px;
            background: #0DA982;
            box-shadow: 0px 10px 35px 0px #6F7EC940;
            border:none;
            cursor:pointer;
        }
        .no-btn{
            color:#fff;
            font-weight:700;
            font-size:16px;
            height:48px;
            padding: 0px 49px;
            border-radius: 15px;
            background: #D81D00;
            box-shadow: 0px 10px 35px 0px #6F7EC940;
            border:none;
            cursor:pointer;
        }
    }
`;